import { reactive, toRefs } from 'vue';

const state = reactive({
    headerHeight: 0,
});

export default function useAppHeader() {
    const { headerHeight } = toRefs(state);

    function setHeaderHeight(height: number) {
        state.headerHeight = height;
    }

    return {
        headerHeight,
        setHeaderHeight
    }
}